<template #content>
    <div id="Post_To_Axxess_Care" class="post-care-box border-0">
        <section v-if="isLoading">
            <section class="p-5 d-flex flex-column text-center text-primary">
                <i class="fa fa-spinner fa-spin font-size-5xl me-2 animated slow flash infinite"></i>
                <span class="mt-1">
                    <b>Loading...</b>
                </span>
            </section>
        </section>
        <template v-else>
            <h1 class="post-care-head text-center fw-bold p-2 text-white border-0">AxxessCare</h1>
            <div>
                <div>
                    <div></div>
                    <div class="col">
                        <h6 class="post-care-text fw-bold text-center post-care-text">
                            You are now posting these visits to AxxessCARE
                        </h6>
                        <div class="d-flex justify-content-between align-items-center row px-3 py-2">
                            <div class="col">
                                <p class="fw-bold">Visit</p>
                                <p class="list_text" v-for="(date, index) of visitDetails?.visitDates" :key="index">
                                    {{ visitDetails?.visitType }}
                                </p>
                            </div>
                            <div class="col">
                                <p class="fw-bold">Task</p>
                                <p class="list_text" v-for="(date, index) of visitDetails?.visitDates" :key="index">
                                    {{ visitDetails?.specialityName }}
                                </p>
                            </div>
                            <div class="col">
                                <p class="fw-bold">Date</p>
                                <p class="list-text" v-for="(date, index) of visitDetails?.visitDates" :key="index">
                                    {{ date }}
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="row px-3 py-2">
                        <div class="form-group col">
                            <label for="visit-details" class="fw-bold">Visit Details</label>
                            <textarea
                                class="form-control form-control-sm"
                                name="visit-details"
                                id="visit-details"
                                v-model="postToAxxessCareDetails.VisitDetails"
                                rows="5"
                                placeholder="Visible to all applicants. Please limit to non-HIPAA info."
                            ></textarea>
                        </div>
                        <div class="form-group col">
                            <label for="hipaa-info" class="fw-bold">HIPAA Protected Information</label>
                            <textarea
                                class="form-control form-control-sm"
                                name="hipaa-info"
                                id="hipaa-info"
                                v-model="postToAxxessCareDetails.HipaaInfo"
                                rows="5"
                                placeholder="Visible to only the assigned clinician."
                            ></textarea>
                        </div>
                    </div>
                    <div class="row px-3 py-2">
                        <div with.bind="postToAxxessCareDetails" class="col d-flex justify-content-between">
                            <div>
                                <div class="fw-bold">
                                    Address<i
                                        @click="editAddress()"
                                        class="cursor-pointer fas fa-edit ms-2 edit-icon"
                                    ></i>
                                </div>
                                <div class="">
                                    <div v-if="postToAxxessCareDetails.AddressLine1">
                                        {{ postToAxxessCareDetails.AddressLine1 }}
                                    </div>
                                    <div v-if="postToAxxessCareDetails.AddressLine2">
                                        {{ postToAxxessCareDetails.AddressLine2 }}
                                    </div>
                                    <div
                                        v-if="
                                            postToAxxessCareDetails.City ||
                                            postToAxxessCareDetails.StateCode ||
                                            postToAxxessCareDetails.ZipCode
                                        "
                                    >
                                        {{ postToAxxessCareDetails.City }} {{ postToAxxessCareDetails.StateCode }}
                                        {{ postToAxxessCareDetails.ZipCode }}
                                    </div>
                                </div>
                            </div>
                            <div class="me-md-3">
                                <div class="fw-bold">
                                    Pay Rate<i
                                        @click="editPayRate()"
                                        class="cursor-pointer fas fa-edit ms-2 edit-icon"
                                    ></i>
                                </div>
                                <div v-if="PayRates && PayRates.length">
                                    <div v-for="(rate, index) of PayRates" :key="index">
                                        {{ rate.Label }}: ${{ rate.Rate }}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div>
                            <span class="form-group form-check mb-0 mt-3">
                                <input
                                    :checked="postToAxxessCareDetails.PrivateJob"
                                    v-model="postToAxxessCareDetails.PrivateJob"
                                    type="checkbox"
                                    class="form-check-input"
                                    id="privatePostCheckBoxNew"
                                />
                                <label class="form-check-label internal-visit fw-bold" for="privatePostCheckBoxNew"
                                    >Post visit internally. (Only your staff will be able to apply.)</label
                                >
                            </span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="d-block justify-content-right py-3 p-md-3 text-center text-md-end post-to-axxessCare">
                <button class="axxesscare-confirm btn me-2 text-white border-0" @click="postToAxxessCare()">
                    Confirm Posting
                </button>
                <button class="btn" @click="cancel()">Cancel</button>
            </div>
        </template>
    </div>
</template>

<style src="./MultipleVisitAxxesscare.scss"></style>
<script lang="ts" src="./MultipleVisitAxxesscare.ts"></script>
